<template>
  <div v-if="qrImage" class="qr-code">
    <h3><i class="fas fa-qrcode"></i> El teu codi QR</h3>
    <img :src="qrImage" alt="Codi QR per a vCard">
    <p>Escaneja aquest codi QR per desar la informació de contacte</p>
  </div>
</template>

<script>
export default {
  name: 'QRCodeDisplay',
  props: {
    qrImage: {
      type: String,
      default: null
    }
  }
}
</script>

<style scoped>
.qr-code {
  margin-top: 30px;
  padding: 20px;
  background: #fff;
  border-radius: 16px;
  box-shadow: 0 8px 25px rgba(0, 0, 0, 0.1);
  border: 1px solid #e2e8f0;
}

.qr-code img {
  max-width: 100%;
  height: auto;
  border-radius: 12px;
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.1);
}
</style>